export default {
  state: {
    ordersFilter: {},
    combinedOrdersFilter: {},
    invoicesFilter: {},
    usersFilter: {},
    reportsFlightsFilter: {},
    reportsSelfServeFilter: {},
    reportsFlightsProfitLossFilter: {},
    reportsBagsFilter: {},
    reportsBagsAddOrderInBagFilter: {},
    settingsMessengerTranslationsFilter: {},
    reportsDeliveryFilter: {},
    reportsWalkinFilter: {},
    reportsShelfHistoryFilter: {},
    reportsSummaryFilter: {},
    translationsFilter: {},
    settingsWebSiteAddresses: {},
    settingsDutiesFilter: {},
  },
  mutations: {
    setOrdersFilter(state, payload) {
      state.ordersFilter = payload;
    },
    setCombinedOrdersFilter(state, payload) {
      state.combinedOrdersFilter = payload;
    },
    setInvoicesFilter(state, payload) {
      state.invoicesFilter = payload;
    },
    setUsersFilter(state, payload) {
      state.usersFilter = payload;
    },
    setReportsFlightsFilter(state, payload) {
      state.reportsFlightsFilter = payload;
    },
    setReportsSelfServeFilter(state, payload) {
      state.reportsSelfServeFilter = payload;
    },
    setReportsFlightsProfitLossFilter(state, payload) {
      state.reportsFlightsProfitLossFilter = payload;
    },
    setReportsBagsFilterFilter(state, payload) {
      state.reportsBagsFilter = payload;
    },
    setReportsBagsAddOrderInBagFilter(state, payload) {
      state.reportsBagsAddOrderInBagFilter = payload;
    },
    setMessengerTranslationsFilter(state, payload) {
      state.settingsMessengerTranslationsFilter = payload;
    },
    setReportsDeliveryFilter(state, payload) {
      state.reportsDeliveryFilter = payload;
    },
    setReportsWalkinFilter(state, payload) {
      state.reportsWalkinFilter = payload;
    },
    setReportsShelfHistoryFilter(state, payload) {
      state.reportsShelfHistoryFilter = payload;
    },
    setReportsSummaryFilter(state, payload) {
      state.reportsSummaryFilter = payload;
    },
    setTranslationsFilterFilter(state, payload) {
      state.translationsFilter = payload;
    },
    setSettingsWebSiteAddressesFilterFilter(state, payload) {
      state.settingsWebSiteAddresses = payload;
    },
    setSettingsDutiesFilterFilter(state, payload) {
      state.settingsDutiesFilter = payload;
    },
  },
  actions: {
    setOrdersFilter({commit}, payload) {
      commit('setOrdersFilter', payload);
    },
    setCombinedOrdersFilter({commit}, payload) {
      commit('setCombinedOrdersFilter', payload);
    },
    setInvoicesFilter({commit}, payload) {
      commit('setInvoicesFilter', payload);
    },
    setUsersFilter({commit}, payload) {
      commit('setUsersFilter', payload);
    },
    setReportsFlightsFilter({commit}, payload) {
      commit('setReportsFlightsFilter', payload);
    },
    setReportsSelfServeFilter({commit}, payload) {
      commit('setReportsSelfServeFilter', payload);
    },
    setReportsFlightsProfitLossFilter({commit}, payload) {
      commit('setReportsFlightsProfitLossFilter', payload);
    },
    setReportsBagsFilter({commit}, payload) {
      commit('setReportsBagsFilterFilter', payload);
    },
    setReportsBagsAddOrderInBagFilter({commit}, payload) {
      commit('setReportsBagsAddOrderInBagFilter', payload);
    },
    setMessengerTranslationFilter({commit}, payload) {
      commit('setMessengerTranslationsFilter', payload);
    },
    setReportsDeliveryFilter({commit}, payload) {
      commit('setReportsDeliveryFilter', payload);
    },
    setReportsWalkinFilter({commit}, payload) {
      commit('setReportsWalkinFilter', payload);
    },
    setReportsShelfHistoryFilter({commit}, payload) {
      commit('setReportsShelfHistoryFilter', payload);
    },
    setReportsSummaryFilter({commit}, payload) {
      commit('setReportsSummaryFilter', payload);
    },
    setTranslationsFilterFilter({commit}, payload) {
      commit('setTranslationsFilterFilter', payload);
    },
    setSettingsWebSiteAddressesFilterFilter({commit}, payload) {
      commit('setSettingsWebSiteAddressesFilterFilter', payload);
    },
    setSettingsDutiesFilterFilter({commit}, payload) {
      commit('setSettingsDutiesFilterFilter', payload);
    },
  },
  getters: {
    getOrdersFilter(state) {
      return state.ordersFilter;
    },
    getCombinedOrdersFilter(state) {
      return state.combinedOrdersFilter;
    },
    getInvoicesFilter(state) {
      return state.invoicesFilter;
    },
    getUsersFilter(state) {
      return state.usersFilter;
    },
    getReportsFlightsFilter(state) {
      return state.reportsFlightsFilter;
    },
    getReportsSelfServeFilter(state) {
      return state.reportsSelfServeFilter;
    },
    getReportsFlightsProfitLossFilter(state) {
      return state.reportsFlightsProfitLossFilter;
    },
    getReportsBagsFilter(state) {
      return state.reportsBagsFilter;
    },
    getReportsBagsAddOrderInBagFilter(state) {
      return state.reportsBagsAddOrderInBagFilter;
    },
    getMessengerTranslationsFilter(state) {
      return state.settingsMessengerTranslationsFilter;
    },
    getReportsDeliveryFilter(state) {
      return state.reportsDeliveryFilter;
    },
    getReportsWalkinFilter(state) {
      return state.reportsWalkinFilter;
    },
    getReportsShelfHistoryFilter(state) {
      return state.reportsShelfHistoryFilter;
    },
    getReportsSummaryFilter(state) {
      return state.reportsSummaryFilter;
    },
    getTranslationsFilterFilter(state) {
      return state.translationsFilter;
    },
    getSettingsWebSiteAddressesFilterFilter(state) {
      return state.settingsWebSiteAddresses;
    },
    getSettingsDutiesFilterFilter(state) {
      return state.settingsDutiesFilter;
    },
  }
}
